import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid2";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import PairCurrencyMismatch from "./PairCurrencyMismatchModal/PairCurrencyMismatch";
import React from "react";

const PairingRecordsChosenHead = () => {
  const [openModal, setOpenModal] = React.useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Box sx={{ padding: " 16px " }}>
        <Grid container spacing={2} alignItems="center">
          <Grid size={7}>
            <Typography variant="h3" sx={{ fontSize: "24px" }}>
              Receipts Pairing
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              Match Receipts to FME records and keep track of your payments.
            </Typography>
          </Grid>
          <Grid
            size={5}
            container
            spacing={2}
            flexDirection={"row"}
            justifyContent={"flex-end"}
          >
            <Button
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              endIcon={<SaveOutlinedIcon />}
              onClick={handleOpenModal}
            >
              SAVE & UPLOAD
            </Button>
            <PairCurrencyMismatch
              open={openModal}
              handleClose={handleCloseModal}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default PairingRecordsChosenHead;
